var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DatePicker',_vm._b({attrs:{"fromPage":_vm.fromPage,"toPage":_vm.toPage,"max-date":new Date()},on:{"input":_vm.onChange}},'DatePicker',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }